// 大手町
export const DEFAULT_LOCATION = { lat: 35.6870985, lng: 139.764569 };
